import api from '@/api';
import _ from 'lodash';

const state = {
  address: '',
  attending: null,
  revoked: false,
  code: '',
  customUnitData: {shares: '1'},
  email: '',
  name: '',
  unit: '',
  isVerified: false,
  multiConsent: null,
  communicationPreferences: null
};

const getters = {
  voter: state => state,
  isVerified: state => state.isVerified,
  isAttending: state => state.isVerified && state.attending,

  // If unit has an ineligible_reason flag or shares=0,
  // voting is disabled for this voter
  isVotingDisabled: state => {
    // First, check for ineligible_reason flag
    if (
      state.customUnitData &&
      'ineligible_reason' in state.customUnitData &&
      state.customUnitData.ineligible_reason !== ''
    ) {
      return true;
    }
    // Otherwise: default case, no shares means default share of 1
    if (!state.customUnitData || !('shares' in state.customUnitData)) {
      return false;
    }
    // If shares is not a number, then sometimes is wrong and just disable
    if (isNaN(state.customUnitData.shares)) {
      return true;
    }
    // Otherwise check that shares is > 0
    return parseFloat(state.customUnitData.shares) <= 0;
  },
  noVoterMultiConsent: (state, getters, rootState) => {
    // Note: Must allow state, getters and rootState params
    // Check consent format & voter consent & test voter status
    const consentFormat = _.get(rootState, 'meetingOptions.consent_format');
    const votingConsent = _.get(state, 'multiConsent.voting_consent', false);
    const isTestVoter = _.get(state, 'communicationPreferences.isTestVoter');

    // Bypass voting consent check if test voter
    if (isTestVoter) {
      return false;
    }

    return consentFormat === 'multi-consent' && !votingConsent;
  }
};

const actions = {
  setVoter({commit}, voter) {
    return commit('SET_VOTER', voter);
  },

  /**
   * Marks the owner as attending the meeting
   * @param {String} shortCode - the shortCode
   * @param {String} token     - the voter Token
   */
  async markRsvp({commit}, {shortCode, token, isAttending}) {
    try {
      await api.postVoterAttending(shortCode, token, isAttending);
      return commit('SET_ATTENDING', true);
    } catch (err) {
      throw err;
    }
  },

  /**
   * Self-revokes submissions
   * @param {String} shortCode - the shortCode
   * @param {String} token     - the voter Token
   */

  async revokeSubmissions({commit}, {shortCode, token}) {
    try {
      const res = await api.postRevokeSubmissions(shortCode, token);
      commit('SET_REVOKED', true);
      return res;
    } catch (err) {
      throw err;
    }
  },

  clearVoter({commit}) {
    return commit('SET_VOTER', {
      address: '',
      attending: null,
      code: '',
      customUnitData: {},
      email: '',
      name: '',
      unit: '',
      isVerified: false,
      communicationPreferences: null
    });
  }
};

const mutations = {
  /**
   * Set the attending flag
   * @param {Object} state        the state
   * @param {Object} voter        the voter object
   */
  SET_VOTER(state, voter) {
    state.address = voter.address;
    state.attending = voter.attending;
    state.code = voter.code;
    state.customUnitData = voter.customUnitData;
    state.email = voter.email;
    state.name = voter.name;
    state.unit = voter.unit;
    state.isVerified = voter.isVerified;
    state.multiConsent = voter.multiConsent;
    state.communicationPreferences = voter.communicationPreferences;
  },

  /**
   * Set the attending flag
   * @param {Object} state        the state
   * @param {Boolean} attending   set the attending value
   */
  SET_ATTENDING(state, attending) {
    state.attending = attending;
  },

  /**
   * Set the revocation flag
   * @param {Object} state        the state
   * @param {Boolean} attending   set the revocation value
   */

  SET_REVOKED(state, revoked) {
    state.revoked = revoked;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/vuex/modules/voter.js